// extracted by mini-css-extract-plugin
export default {"Titles":"Title_Titles__nCTO+","phone":"Title_phone__Dk9hl","text":"Title_text__1mjhp","title":"Title_title__TfgK3","subtitle":"Title_subtitle__TZ8+4"};